import { Icon } from '@iconify/react';

export const InsoleIcon = (props: { size?: number; color?: string }) => (
  <Icon
    icon="healthicons:orthotics"//icon="maki:shoe"
    width={props.size ?? 24}
    height={props.size ?? 24}
  />
);
export const ShoeIcon = (props: { size?: number; color?: string }) => (
  <Icon
    icon="maki:shoe"
    width={props.size ?? 24}
    height={props.size ?? 24}
  />
);

export const SlipperIcon = (props: { size?: number; color?: string }) => (
  <Icon
    icon="icon-park-solid:slippers"
    width={props.size ?? 24}
    height={props.size ?? 24}
  />
);

export const FlipFlopIcon = (props: { size?: number; color?: string }) => (
  <Icon
    icon="game-icons:flip-flops"
    width={props.size ?? 24}
    height={props.size ?? 24}
    style={{ transform: "rotate(90deg)" }}
  />
);

export const HighHeelIcon = (props: { size?: number; color?: string }) => (
  <Icon
    icon="emojione-monotone:high-heeled-shoe" //"picon:shoe" 
    width={props.size ?? 24}
    height={props.size ?? 24}
  />
);

export const ThongSandalIcon = (props: { size?: number; color?: string }) => (
  <Icon
    icon="noto:thong-sandal"
    width={props.size ?? 24}
    height={props.size ?? 24}
  />
);

export const TemplateIcon = (props: { size?: number; color?: string }) => (
  <Icon
    icon="heroicons-solid:template"
    width={props.size ?? 24}
    height={props.size ?? 24}
  />
);
export const FeetBoneIcon = (props: { size?: number; color?: string }) => (
  <Icon
    icon="material-symbols:foot-bones"
    width={props.size ?? 24}
    height={props.size ?? 24}
  />
);
export const FootPressureIcon = (props: { size?: number; color?: string }) => (
  <Icon
    icon="glyphs:foot-print-bold"
    width={props.size ?? 24}
    height={props.size ?? 24}
  />
);

export const GCodeObjectExportIcon = (props: { size?: number; color?: string }) => (
  <Icon
    icon="tabler:file-3d"
    width={props.size ?? 24}
    height={props.size ?? 24}
    color={props.color}
  />
);

export const LowpolyExportIcon = (props: { size?: number; color?: string }) => (
  <Icon
    icon="tabler:polygon"
    width={props.size ?? 24}
    height={props.size ?? 24}
    color={props.color}
  />
);

export const Foot3DIcon = (props: { size?: number; color?: string }) => (
  <Icon
    icon="healthicons:foot"
    width={props.size ?? 24}
    height={props.size ?? 24}
    color={props.color}
  />
);